import type { ReactNode } from "react"
import Media from "@gatsby-plugin-generic-page/components/Media"
import { SquidexComponentType } from "@gatsby-plugin-generic-page/types/componentType"
import type { Navigation } from "@gatsby-plugin-onestore/fragments/navigation"
import { typeMatches } from "@onestore-graphql"
import DynamicUdsIcon from "~/components/DynamicUdsIcon"
import type { ImageElementComponent } from "~/fragments/imageElement"
import type { SystemUdsIconsComponent } from "~/fragments/systemUdsIcons"
import isEmpty from "../../../../src/lib/isEmpty"

export default function buildNavIconElement(
  icon: Navigation["icon"]
): ReactNode | null {
  if (isEmpty(icon)) return null

  if (typeMatches(icon.__typename, SquidexComponentType.SYSTEM_UDS_ICONS)) {
    return (
      <DynamicUdsIcon
        iconName={(icon as SystemUdsIconsComponent).iconId}
        iconGroup="system"
        size="medium"
      />
    )
  }

  if (typeMatches(icon.__typename, SquidexComponentType.IMAGE_ELEMENT)) {
    return !isEmpty((icon as ImageElementComponent).image) ? (
      <Media
        media={(icon as ImageElementComponent).image!}
        maxWidth={20}
        maxHeight={20}
      />
    ) : null
  }

  return null
}
